const state = {
    rawdata: '',
    done: false,
    product_raw_data: '',
    flash_text_orgn: '',
    spacey_orgn: '',
    emails_item_refs: [],
    user_id: null,
    sidebar: [],
    allowed_sectors: [],
    current_active_module: null,
    big_loading:false,
    dashboardType:'focus',
    // update_checkboxed: false,
}

export default state
